const SuggestionsStyle = {
    baseStyle: {
        image: {
            imgSizes: '30vw'
        },
        productInfoBox: {
            main: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                paddingLeft: '0px',
                marginTop: {base: '10px', lg: '0'},
                marginBottom: {base: '200px !important', lg: '0px'},
                height: 'auto',
                width: '120px'
            },
            productName: {
                fontWeight: '300',
                fontSize: '15px',
                color: 'black.100',
                noOfLines: 2,
                marginBottom: '10px',
                whiteSpace: 'pre-wrap'
            },
            productPrice: {
                fontWeight: '300',
                fontSize: '13px',
                color: 'black.100'
            }
        },
        container: {
            padding: {base: '1rem 0 0 1rem', lg: '1rem 3rem 3rem 1rem'},
            spacing: 0,
            marginRight: {base: '-1rem', lg: 'auto'},
            flexDirection: {lg: 'unset'},
            display: {base: 'contents', lg: 'flex'}
        },
        phaseCategoriesWrapper: {
            main: {
                width: {lg: '40%'},
                padding: {lg: '3rem 1rem 1rem 1rem'},
                marginTop: {md: '20px', base: '20px', lg: '0'}
            },
            name: {
                fontWeight: '700',
                color: 'black',
                textDecoration: 'underline'
            },
            heading: {
                margin: '0 0 20px 0',
                color: 'gray.800',
                fontSize: '23px',
                fontWeight: '400'
            }
        },
        mobileCategories: {
            main: {
                display: {base: 'block', md: 'block', lg: 'none'},
                marginBottom: '20px'
            },
            heading: {
                margin: '0 0 20px 0',
                color: 'gray.800',
                fontSize: '23px',
                fontWeight: '400'
            }
        },
        productSuggestions: {
            main: {
                width: {lg: '60%'},
                padding: {lg: '3rem 1rem 1rem 1rem'}
            },
            heading: {
                marginBottom: '20px',
                paddingLeft: {base: '0px', lg: '40px'},
                color: 'gray.800',
                fontSize: '23px',
                fontWeight: '400'
            },
            desktopSwiperParent: {
                gap: '20px',
                sx: {
                    '.swiper': {
                        paddingRight: '20px',
                        paddingTop: '47px',
                        marginTop: '-7px'
                    },
                    '.swiper-wrapper': {
                        paddingLeft: {base: '20px', xs: '30px', lg: '40px'}
                    },
                    '.swiper-slide': {
                        width: {base: '175px', lg: '300px'},

                        '&:last-child': {
                            marginRight: {
                                base: '20px !important',
                                xs: '30px !important',
                                lg: '60px !important'
                            }
                        }
                    }
                }
            },
            mobileLayout: {
                display: 'flex',
                overflowX: 'auto',
                scrollSnapType: 'x mandatory',
                gap: 4,
                css: {
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    }
                }
            },
            skeleton: {
                width: '100px',
                height: '30px',
                marginBottom: '20px'
            },
            suggestionBox: {
                flex: '0 0 auto',
                width: 'fit-content',
                display: 'block',
                style: {
                    scrollSnapAlign: 'start'
                }
            }
        },
        divider: {
            width: {lg: '50%'},
            borderColor: 'gray.400',
            margin: '1.5rem 0'
        },
        term: {
            button: {
                width: 'full',
                height: 9,
                _hover: {
                    textDecoration: 'none',
                    color: 'teal.400'
                },
                transition: 'color 0.3s ease',
                padding: 0,
                marginTop: 0,
                variant: 'menu-link'
            },
            text: {
                fontSize: '14px',
                margin: {lg: '8px 30px', base: '8px 0px'},
                fontWeight: '300'
            }
        }
    }
}

export default SuggestionsStyle
